import state from './moduleLookupState.js'
import mutations from './moduleLookupMutations.js'
import actions from './moduleLookupActions.js'
import getters from './moduleLookupGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}